import { post } from './api';

const DEFAULT_SOURCE_LANGUAGE = process.env.TRANSLATION_DEFAULT_SOURCE_LANGUAGE || 'en';

export const translateHostedConfigClient = async (hostedConfig, language) => {
  if (!hostedConfig || !language || language === DEFAULT_SOURCE_LANGUAGE) {
    return hostedConfig;
  }

  try {
    const response = await post(
      '/api/translate-config',
      {
        config: hostedConfig,
        targetLanguage: language,
      },
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (response?.data) {
      return response.data;
    }
  } catch (error) {
    console.error('Failed to translate hosted config', error);
  }

  return hostedConfig;
};

export default translateHostedConfigClient;
